import step3 from "../feature/step3.webp"; 
import step2 from "../feature/step2.webp";
import step1 from "../feature/step1.webp";

function HIWorks(){    

    return (
        <>        
            <div className="col-12 text-center mt-5 pt-6indx0-scroll" id='features'>
                <div className="container containerwide">

                    {/* HEADLINE */}
                    <h1 className="mb-5 text-left mpl-3 fw800">
                        <b>
                            How Kadhr{" "}
                            <span className="bg-gold-yellow">Works</span> 
                        </b>
                    </h1>

                    {/* SCROLL WRAPPER */}
                    <div className="row flex-nowrap overflow-auto d-lg-flex flex-lg-wrap">

                        {/* STEP 1 */}
                        <div className="col-lg-4 col-10 d-flex flex-shrink-0 mpl-4 mpr-0">
                            <div className='card p-4 pb-0 bordered-4 w-100 d-flex flex-column justify-content-between'>

                                <div className="text-left">
                                    <h4 className="mb-2 smallh4 fw800"><b>1. Unify your sales data</b></h4>
                                    <p className="font8 grey-text mb-2">
                                        Sync orders from POS, WooCommerce, Shopify, Spreadsheets, and more — into one system that continuously learns from your business.
                                    </p>
                                </div>

                                <div className="feature-imgcon1 mt-3">
                                    <img src={step1} className='w-100 h-100 pb-4' alt='#' />
                                </div>

                            </div>
                        </div>

                        {/* STEP 2 */}
                        <div className="col-lg-4 col-10 d-flex flex-shrink-0 mpl-3 mpr-0">
                            <div className='card p-4 pb-0  bordered-4  w-100 d-flex flex-column justify-content-between'>

                                <div className="text-left">
                                    <h4 className="mb-2 smallh4 fw800"><b>2. Understand customer behavior</b></h4>
                                    <p className="font8 grey-text mb-2">
                                        Understand patterns, timing, and intent as the system adapts to how your customers actually buy.
                                    </p>
                                </div>

                                <div className="feature-imgcon1 mt-3">
                                    <img src={step2} className='w-100 h-100 pb-4' alt='#' />
                                </div>

                            </div>
                        </div>

                        {/* STEP 3 */}
                        <div className="col-lg-4 col-10 d-flex flex-shrink-0 mpl-3 mpr-4">
                            <div className='card p-4 pb-0  bordered-4  w-100 d-flex flex-column justify-content-between'>

                                <div className="text-left">
                                    <h4 className="mb-2 smallh4 fw800"><b>3. Trigger timely interactions</b></h4>
                                    <p className="font8 grey-text mb-2">
                                        Automatically reach customers at the right moment with messages that feel natural and drive repeat sales.
                                    </p>
                                </div>

                                <div className="feature-imgcon1 mt-3">
                                    <img src={step3} className='w-100 h-100 pb-4' alt='#' />
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div> 
        </>
    )
}

export default HIWorks;